import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "oneloan_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach bearer token (alongside httpOnly cookie) for cross-origin reliability
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitLead = (payload) => api.post("/leads", payload).then(r => r.data);
export const submitCallback = (payload) => api.post("/callbacks", payload).then(r => r.data);
export const submitContact = (payload) => api.post("/contacts", payload).then(r => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then(r => r.data);
export const adminGet = (path, token) => api.get(`/admin/${path}`, { headers: { "X-Admin-Token": token } }).then(r => r.data);
export const adminDownloadDocument = (id, token) =>
  api.get(`/admin/documents/${id}/download`, { headers: { "X-Admin-Token": token }, responseType: "blob" }).then(r => r.data);

// ===== Auth =====
export const exchangeSession = (sessionId) =>
  api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } }).then(r => r.data);
export const fetchMe = () => api.get("/auth/me").then(r => r.data);
export const logoutApi = () => api.post("/auth/logout").then(r => r.data);
export const registerUser = (payload) => api.post("/auth/register", payload).then(r => r.data);
export const loginUser = (payload) => api.post("/auth/login", payload).then(r => r.data);

// ===== Profile =====
export const getProfile = () => api.get("/me/profile").then(r => r.data);
export const updateProfile = (payload) => api.patch("/me/profile", payload).then(r => r.data);
export const getApplications = () => api.get("/me/applications").then(r => r.data);

// ===== Documents =====
export const uploadDocument = (formData, onUploadProgress) =>
  api.post("/me/documents", formData, { headers: { "Content-Type": "multipart/form-data" }, onUploadProgress }).then(r => r.data);
export const listDocuments = () => api.get("/me/documents").then(r => r.data);
export const downloadDocument = (id) => api.get(`/me/documents/${id}/download`, { responseType: "blob" }).then(r => r.data);
export const deleteDocument = (id) => api.delete(`/me/documents/${id}`).then(r => r.data);
